import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  MonthPicker,
  NewTableAdv,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../components";
import * as XLSX from "xlsx";

import { PayrollProviders } from "../../../../assets/data/enumData";
import { dateFormator, getEmployeeId, mapTableRows } from "../../../../utils";
import { formatCurrency, formatWords2 } from "../../../../utils/stringUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  clearReconciliationData,
  getReconciliationsStart,
  updateReconciliationStart,
} from "../../../../redux/slices/reconciliation/reconciliationSlice";
import { usePagination } from "../../../../hooks";
import dayjs from "dayjs";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axios from "axios";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { exactUTCDate } from "../../../../utils/dateFormator";
// import {AccordionComponentForTable} from "../../../../pages/InnerPages/ComponentsList/List/AccrodianComponent"


export const AccordionComponentForTable = ({ rowData }) => {
  if (!rowData || (Array.isArray(rowData) && rowData.length === 0)) {
    return <div className="p-2">No data available</div>
  }

  const normalizedData = Array.isArray(rowData) ? rowData : rowData.records

  return (
    <div className="max-h-80 overflow-y-auto border rounded-md">
      <table className="min-w-full border-collapse text-sm">
        <thead className="sticky top-0 bg-gray-100 text-gray-700">
          <tr>
            <th className="px-4 py-2 text-left border-b font-medium">Pay Date</th>
            <th className="px-4 py-2 text-left border-b font-medium">Time Period</th>
            <th className="px-4 py-2 text-left border-b font-medium">Gross Pay</th>
          </tr>
        </thead>
        <tbody>
          {normalizedData.map((record, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
              <td className="px-4 py-2 border-b">{exactUTCDate(record.payDate)}</td>
              <td className="px-4 py-2 border-b">
                {`${exactUTCDate(record?.timeperiod?.from)} - ${exactUTCDate(record?.timeperiod?.to)}`}
              </td>
              <td className="px-4 py-2 border-b">{exactUTCDate(record.cost)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}



const PayrollSummary = (props) => {
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData;
  //states
  //for overwrite modal
  const [overWriteConfirm, setOverWriteConfirm] = useState(false);
  const [overwriteStatus, setOverwriteStatus] = useState(false);

  const [paginationMap, setPaginationMap] = useState({});
  const [totalCountMap, setTotalCountMap] = useState({});

  const [totalVersions, setTotalVersions] = useState(0);
  const [versionsData, setVersionsData] = useState({});

  const dispatch = useDispatch();

  const {
    loading,
    error,
    reconciliation = [],
    totalCount = null,
  } = useSelector((state) => state.reconciliation);

  const getKeyWord = (provider, withBrackets = false) => {
    switch (provider) {
      case "Quickbooks":
        return withBrackets ? "(QB)" : "QB";
      case "Adp":
        return withBrackets ? "(ADP)" : "ADP";
      default:
        return "";
    }
  };
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      provider: "",
      monthyear: "",
      excelsheet: [],
    },
    {
      provider: { type: "select", required: true },
      excelsheet: {
        type: "file",
        required: true,
        allowedFiles: [
          {
            ext: ".xlsx",
            mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          { ext: ".xls", mime: "application/vnd.ms-excel" },
        ],
      },
    }
  );

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {}
  );
  const getPagination = (version) => {
    return {
      page: paginationMap[version]?.page || 1,
      limit: paginationMap[version]?.limit || 10,
      setPage: (newPage) =>
        setPaginationMap((prev) => ({
          ...prev,
          [version]: { ...prev[version], page: newPage },
        })),
      handleLimitChange: (newLimit) =>
        setPaginationMap((prev) => ({
          ...prev,
          [version]: { ...prev[version], limit: newLimit, page: 1 },
        })),
    };
  };

  // useEffect(() => {
  //   // setOverwriteStatus(false);
  //   if (!formData?.monthyear || !formData?.provider) return;
  //   const monthyear = dayjs(formData.monthyear);
  //   const month = monthyear.get("month");
  //   const year = monthyear.get("year");
  //   console.log({ month, year });

  //   let totalCount;
  //   const fetchVersions = async () => {
  //     const total = await axiosRequest({
  //       method: "GET",
  //       url: ENDPOINTS.RECONCILIATION.GET_BY_UIID,
  //       params: {
  //         coll: "Reconciliation",
  //         // lim: 1,
  //         // pg: 1,
  //         ret: "version",
  //         fil: JSON.stringify({
  //           provider: { type: "NONE", value: formData.provider },
  //           month: { type: "NONE", value: month },
  //           year: { type: "NONE", value: year },
  //         }),
  //         sort: JSON.stringify({ version: -1 }),
  //         // ref: "Payroll",
  //       },
  //     });
  //     totalCount = total?.data?.data?.version || 0;
  //     console.log("t`otalCount", totalCount);
  //     setTotalVersions(totalCount)
  //     const responseList = [];
  //     for (let i = totalCount; i > 0; i--) {
  //       const response = await axiosRequest({
  //         method: "GET",
  //         url: ENDPOINTS.RECONCILIATION.GET_ALL,
  //         params: {
  //           coll: "Reconciliation",
  //           lim: limit,
  //           pg: page,
  //           fil: JSON.stringify({
  //             provider: { type: "NONE", value: formData.provider },
  //             month: { type: "NONE", value: month },
  //             year: { type: "NONE", value: year },
  //             version: { type: "NONE", value: i },
  //           }),
  //           ref: "Payroll",
  //         },
  //       });
  //       responseList.push(response.data.data);
  //     }
  //     const parsed = {};

  //     responseList.forEach((group) => {
  //       if (group.length > 0) {
  //         const version = group[0].version;
  //         parsed[version] = group;
  //       }
  //     });
  //     setVersionsData(parsed || []);
  //     console.log("response responseList", parsed);
  //   };
  //   fetchVersions();
  //   return () => {
  //     dispatch(clearReconciliationData());
  //   };
  //   // }, [formData.monthyear, formData.provider, formData.excelsheet, page, limit]);
  // }, [formData.monthyear, formData.provider, page, limit]);

  const fetchVersionsMeta = async (supressToast = false) => {
    let total;
    try {
      const monthyear = dayjs(formData.monthyear);
      const month = monthyear.get("month");
      const year = monthyear.get("year");
      total = await axios.get(ENDPOINTS.RECONCILIATION.GET_BY_UIID, {
        params: {
          coll: "Reconciliation",
          ret: "version",
          fil: JSON.stringify({
            provider: { type: "NONE", value: formData.provider },
            month: { type: "NONE", value: month },
            year: { type: "NONE", value: year },
          }),
          sort: JSON.stringify({ version: -1 }),
        },
        withCredentials: true,
      });

      const versionCount = total?.data?.data?.version || 0;
      if (versionCount === 0) {
        throw new Error("Something went wrong");
      }
      setTotalVersions(versionCount);
      showToast(`Found ${versionCount} versions`, "success");

      const initialPagination = {};
      for (let i = 1; i <= versionCount; i++) {
        initialPagination[i] = { page: 1, limit: 10 };
      }
      setPaginationMap(initialPagination);
    } catch (error) {
      // console.error(error.status);
      if (error.status === 404 && !supressToast) {
        showToast("No data found", "error");
      }
      setVersionsData({});
      setTotalVersions(0);
      setPaginationMap({});
      setTotalCountMap({});
    }
  };
  useEffect(() => {
    if (!formData?.monthyear || !formData?.provider) return;

    fetchVersionsMeta();

    return () => {
      dispatch(clearReconciliationData());
    };
  }, [formData.monthyear, formData.provider]);

  // useEffect(() => {
  //   if (!formData?.monthyear || !formData?.provider) return;

  //   const monthyear = dayjs(formData.monthyear);
  //   const month = monthyear.get("month");
  //   const year = monthyear.get("year");

  //   Object.entries(paginationMap).forEach(([version, { page, limit }]) => {
  //     const fetchVersionData = async () => {
  //       const response = await axiosRequest({
  //         method: "GET",
  //         url: ENDPOINTS.RECONCILIATION.GET_ALL,
  //         params: {
  //           coll: "Reconciliation",
  //           lim: limit,
  //           pg: page,
  //           fil: JSON.stringify({
  //             provider: { type: "NONE", value: formData.provider },
  //             month: { type: "NONE", value: month },
  //             year: { type: "NONE", value: year },
  //             version: { type: "NONE", value: parseInt(version) },
  //           }),
  //           ref: "Payroll",
  //         },
  //       });

  //       const data = response?.data?.data || [];
  //       setVersionsData((prev) => ({
  //         ...prev,
  //         [version]: data,
  //       }));
  //     };

  //     fetchVersionData();
  //   });
  // }, [paginationMap, formData.monthyear, formData.provider]);

  useEffect(() => {
    if (!formData?.monthyear || !formData?.provider) return;
    const monthyear = dayjs(formData.monthyear);
    const month = monthyear.get("month");
    const year = monthyear.get("year");

    Object.entries(paginationMap).forEach(([version, { page, limit }]) => {
      const fetchVersionData = async () => {
        const filters = {
          provider: { type: "NONE", value: formData.provider },
          month: { type: "NONE", value: month },
          year: { type: "NONE", value: year },
          version: { type: "NONE", value: parseInt(version) },
        };

        const [dataRes, countRes] = await Promise.all([
          axiosRequest({
            method: "GET",
            url: ENDPOINTS.RECONCILIATION.GET_ALL,
            params: {
              coll: "Reconciliation",
              lim: limit,
              pg: page,
              fil: JSON.stringify(filters),
              ref: "Payroll Employee",
            },
          }),
          axiosRequest({
            method: "GET",
            url: ENDPOINTS.RECONCILIATION.GET_TOTAL_COUNT,
            params: {
              coll: "Reconciliation",
              ret: "count",
              fil: JSON.stringify(filters),
            },
          }),
        ]);

        const data = dataRes?.data?.data || [];
        const totalCount = countRes?.data?.data || 0;

        setVersionsData((prev) => ({
          ...prev,
          [version]: data,
        }));

        setTotalCountMap((prev) => ({
          ...prev,
          [version]: totalCount,
        }));
      };
      fetchVersionData();
    });
    // }, [paginationMap, formData.monthyear, formData.provider]);
  }, [paginationMap]);

  const columns = [
    {
      key: "name",
      label: `Name ${getKeyWord(formData.provider, true)}`,
      showAccordianBtn: true,
    },
    {
      key: "payDate",
      label: `Pay Date ${getKeyWord(formData.provider, true)}`,
    },
    {
      key: "timePeriod",
      label: `Time Period ${getKeyWord(formData.provider, true)}`,
    },
    {
      key: "timePeriodKW",
      label: "Time Period (KW)",
      className: "bg-neutral-100/80 font-semibold ",
    },
    // {
    //   key: "totalHrs",
    //   label: `Total Hours ${getKeyWord(formData.provider, true)}`,
    // },
    // {
    //   key: "totalHrs",
    //   label: "Hours (Total)",
    // },
    // {
    //   key: "totalHrsSal",
    //   label: "Hours (Sal)",
    // },

    {
      key: "totalHrsKW",
      label: "Total Hours (KW)",
      className: "bg-neutral-100/80 font-semibold ",
    },
    {
      key: "totalPayrollCost",
      // label: `Total Payroll Cost ${getKeyWord(formData.provider, true)}`,
      label: `Gross Pay ${getKeyWord(formData.provider, true)}`,
    },

    {
      key: "payrollCostKW",
      className: "bg-neutral-100/80 font-semibold ",
      label: "Gross Pay (KW)",
    },

    {
      key: "reconciliation",
      //   label: `Reconciliation (${formData.provider}-KW)`,
      label: `Reconciliation (${getKeyWord(formData.provider)}-KW)`,
      // className:"bg-yellow-100 font-semibold ",
      className: "bg-amber-100/20 font-semibold ",
      render: (row) => {
        const value = row?.reconciliation === "-" ? 0 : row?.reconciliation;
        const color =
          value > 0
              ? "text-green-500"
              : value < 0
              ? "text-red-500"
              : "text-blue-500"
        return <span className={`${color}`}>{formatCurrency(value)}</span>;
      },
    },
  ];

  //mapper
  // const mappedData =
  //   reconciliation.length > 0
  //     ? (reconciliation || [])?.map((row, i) => ({
  //         id: row._id || i,
  //         // name: row?.payrollId?.employeeId || "",
  //         name:
  //           row?.name?.firstName && row?.name?.firstName
  //             ? formatWords2(row?.name?.firstName + " " + row?.name?.lastName)
  //             : "-",
  //         payDate: dateFormator(row?.payDate) || "",
  //         timePeriod:
  //           `${dateFormator(row?.timeperiod?.from)} - ${dateFormator(
  //             row?.timeperiod?.to
  //           )}` || "",
  //         totalHrs: (row?.totalHrs || 0).toFixed(2) || "",
  //         totalHrsSal: (row?.paidHrs || 0).toFixed(2) || "",
  //         totalPayrollCost: formatCurrency(row.cost) || "",
  //         timePeriodKW:
  //           `${dateFormator(row?.payrollId?.payCycle?.from)} - ${dateFormator(
  //             row?.payrollId?.payCycle?.to
  //           )}` || "",
  //         totalHrsKW:
  //           (row?.payrollId?.timesheets?.totalHrs || 0).toFixed(2) || "",
  //         payrollCostKW: formatCurrency(row?.payrollId?.amounts?.netPay) || "",
  //         reconciliation:
  //           (row?.cost || 0) - (row?.payrollId?.amounts?.netPay || 0) || "",
  //       }))
  //     : [];
  // const mappedRows = mapTableRows(mappedData, columns);

  //mapper function
  const getMappedRows = (reconciliation) => {
    const mappedData =
      reconciliation.length > 0
        ? (reconciliation || []).map((row, i) => ({
            id: row._id || i,
            name:
              row?.name?.firstName && row?.name?.firstName
                ? [row?.name?.firstName, row?.name?.lastName].filter(Boolean).join(" ")
                : "-",
            payDate: (
              <div>
                {row?.records?.map((data,key) => (
                  <p key={key}>{exactUTCDate(data?.payDate) || ""}</p>
                ))}
              </div>
            ),
            // timePeriod:
            //   `${dateFormator(row?.timeperiod?.from)} - ${dateFormator(
            //     row?.timeperiod?.to
            //   )}` || "",
            //         timePeriod: row?.records
            // ?.map(list => list.timePeriod)
            // .sort((a, b) => new Date(a.from) - new Date(b.from))
            // .reduce((acc, cur, idx, arr) => {
            //   if (idx === 0) acc = cur.from;
            //   if (idx === arr.length - 1) acc += ' - ' + cur.to;
            //   return acc;
            // }, ''),
            timePeriod: (() => {
              const fromdates = row.records?.map(
                (data) => data.timeperiod.from
              );
              const todates = row.records?.map((data) => data.timeperiod.to);
              const alldates = [...fromdates, ...todates].sort(
                (a, b) => new Date(a) - new Date(b)
              );
              return `${exactUTCDate(alldates[0])} - ${exactUTCDate(
                alldates[alldates.length - 1]
              )}`;
            })(),

            // totalHrs: (row?.totalHrs || 0).toFixed(2) || "",
            totalHrs: row?.records?.reduce(
              (acc, data) => (acc += data.totalHrs),
              0
            ),
            // totalHrsSal: (row?.paidHrs || 0).toFixed(2) || "",
            totalHrsSal: row?.records?.reduce(
              (acc, data) => (acc += data.paidHrs),
              0
            ),
            // totalPayrollCost: formatCurrency(row.cost) || "",
            totalPayrollCost: formatCurrency(
              row?.records?.reduce((acc, data) => (acc += data.cost), 0)
            ),
            timePeriodKW:
              `${dateFormator(row?.payrollId?.payCycle?.from)} - ${dateFormator(
                row?.payrollId?.payCycle?.to
              )}` || "",
            totalHrsKW: row?.payrollId?.timesheets?.totalHrs
              ? (row?.payrollId?.timesheets?.totalHrs || 0).toFixed(2)
              : "-" || "",
            payrollCostKW: row?.payrollId?.amounts?.netPay
              ? formatCurrency(row?.payrollId?.amounts?.netPay)
              : "-" || "",
            reconciliation:
              (Math.round(
                (100 * (row?.records?.reduce((acc, data) => (acc += data.cost), 0) -
                  (row?.payrollId?.amounts?.netPay || 0))
                / 100))) || 0,
            records:row?.records || []
          }))
        : [];
    return mapTableRows(mappedData, columns);
  };

  // Usage
  const mappedRows = getMappedRows(reconciliation);

  const handleSearch = async () => {
    if (formData.provider && formData.monthyear && formData.excelsheet.length) {
      if (!overwriteStatus) {
        setOverWriteConfirm(true);
        return;
      }
      setOverwriteStatus(false);
    }
    const isValid = validateAllFields();
    if (isValid) {
      // const monthConverted = new Date(
      //   Date.parse(formData.monthyear.split("/")[0] + " 1")
      // ).toLocaleString("en-US", { month: "long" });
      const monthyear = dayjs(formData.monthyear);
      const month = monthyear.get("month");
      const year = monthyear.get("year");

      const submissionData = {
        coll: "Reconciliation",
        uploadType: "single",
        field: "doc",
        payload: {
          month: month,
          year: year,
          provider: formData.provider,
          doc: formData.excelsheet,
          addedBy: loginUserUiid?.employeeId,
        },
        onSuccess: (result) => {
          if (result.failedCount) {
            // showToast(
            //   `Reconciliation Submitted and ${
            //     result.failedCount ? result.failedCount : 0
            //   } record failed`,
            //   "info"
            // );
            showToast(
              `Reconciliation Submitted: ${
                result.failedCount ? result.failedCount : 0
              } mismatches found.`,
              "info"
            );
          } else {
            showToast("Reconciliation Submitted", "success");
          }
          fetchVersionsMeta(true);
        },
      };
      //upload the file - saga
      dispatch(updateReconciliationStart(submissionData));
      //update the document in saga
    } else {
      showToast(
        "Please fill all the required fields before submitting",
        "error"
      );
    }
  };

  //handleoverwrite
  // const handleOverwrite = async () => {
  //   try {
  //     setOverwriteStatus(true);
  //     await handleSearch();
  //     setOverWriteConfirm(false);
  //   } catch (error) {
  //     console.log("error", error);
  //     showToast("Something went wrong", "error");
  //   }
  // };

  useEffect(() => {
    if (overwriteStatus) {
      handleSearch();
      setOverWriteConfirm(false);
      // setOverwriteStatus(false); // Optional reset
    }
  }, [overwriteStatus]);
  const handleCloseConfirmationModal = () => {
    setOverWriteConfirm(false);
  };

  const downloadExcel = async (version) => {
    const monthyear = dayjs(formData.monthyear);
    const month = monthyear.get("month");
    const year = monthyear.get("year");

    let filters = {
      provider: { type: "NONE", value: formData.provider },
      month: { type: "NONE", value: month },
      year: { type: "NONE", value: year },
      version: { type: "NONE", value: parseInt(version) },
    };

    const res = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.RECONCILIATION.GET_ALL,
      params: {
        coll: "Reconciliation",
        lim: 100000,
        pg: 1,
        ref: "Payroll",
        fil: JSON.stringify(filters),
      },
    });

    const data = res?.data?.data;

    if (!data || data.length === 0) return;

    const tableData = data.map((item) => ({
      // `Name ${getKeyWord(formData.provider)}`: formatWords2(`${item.name.firstName} ${item.name.lastName}`),
      [`Name ${getKeyWord(formData.provider)}`]: [item.name.firstName, item.name.lastName].filter(Boolean).join(" "),
      [`Pay Date ${getKeyWord(formData.provider)}`]: dayjs(item.payDate).format(
        "MM/DD/YYYY"
      ),
      [`Time Period${getKeyWord(formData?.provider)}`]: `${dayjs(
        item?.timeperiod?.from
      ).format("MM/DD/YYYY")} - ${dayjs(item?.timeperiod?.to).format(
        "MM/DD/YYYY"
      )}`,
      "Time Period (KW)": `${dayjs(item?.payrollId?.payCycle?.from).format(
        "MM/DD/YYYY"
      )} - ${dayjs(item?.payrollId?.payCycle?.from).format("MM/DD/YYYY")}`,
      "Total Hours (KW)": item?.payrollId?.timesheets?.totalHrs.toFixed(2),
      [`Gross Pay ${getKeyWord(formData.provider)}`]: `${item?.cost?.toFixed(2) || 0}`,
      "Gross Pay (KW)": `${item?.payrollId?.amounts?.netPay}`,
      [`Reconciliation (${getKeyWord(formData.provider)}-KW)`]: `${
        (item?.cost || 0) - (item?.payrollId?.amounts?.netPay || 0) || ""
      }`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const colWidths = Object.keys(tableData[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...tableData.map((row) => (row[key] ? row[key].toString().length : 0))
      ),
    }));
    worksheet["!cols"] = colWidths;
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reconciliation");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Reconciliation_Report_${dayjs(formData.monthyear).format(
      "MMMM"
    )} - V${version}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="w-full pb-24 mb-24 px-8 py-6 border-[1px] border-neutrals-50 rounded-b h-screen">
      <div className="my-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Payroll Reconciliation"} tag="h6" />
            </div>
          }
        />
      </div>
      <div className="grid  grid-cols-2 lg:grid-cols-[repeat(3,1fr)_0.4fr] max-w-7xl gap-x-8 gap-y-6 mt-4 ">
        <div className="col-span-1">
          <FormFieldSet
            type="select"
            title={"Select Provider"}
            placeholder="Select Provider"
            value={formData.provider}
            onChange={(value) => {
              handleChange("provider", value);
            }}
            options={PayrollProviders}
            error={errors.provider}
            // disabled={isEditable ? (activeAction ? false : true) : false}
          />
        </div>

        <div className="col-span-1 ">
          {/* <CustomMonthYearPicker */}
          <FormFieldSet
            type="monthpicker"
            title={"Select Month & Year"}
            placeholder="Select Month & Year"
            value={formData.monthyear}
            onChange={(value) => handleChange("monthyear", value)}
            error={errors.monthyear}
            // disabled={isEditable ? (activeAction ? false : true) : false}
          />
          {/* working */}
          {/* <MonthPicker
            type="text"
            title={"Select Month & Year"}
            placeholder="Select Month & Year"
            value={formData.monthyear}
            onChange={(value) => handleChange("monthyear", value)}
            error={errors.monthyear}
            // disabled={isEditable ? (activeAction ? false : true) : false}
          /> */}
        </div>

        <div className="col-span-1 ">
          {/* <div className="flex"> */}
          <FormFieldSet
            type="file"
            title={"Upload Excel Sheet"}
            placeholder="Choose File"
            value={formData.excelsheet}
            onChange={(value) => {
              handleChange("excelsheet", value);
            }}
            error={errors.excelsheet}
          />
          {/* </div> */}
        </div>
        <div className="col-span-1 my-6">
          {/* <div className="flex-1"> */}
          {/* <div className="flex my-4"> */}
          <Button
            title={"Submit"}
            //   icon="upload"
            onClick={handleSearch}
          />
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>

      {Object?.entries(versionsData || {})
        ?.sort((a, b) => b[0] - a[0])
        ?.map(([version, data]) => {
          const { page, limit, setPage, handleLimitChange } =
            getPagination(version);
          if (!data?.length) return;
          let addedByName = data[0]?.addedBy?.firstName
            ? ` - ${[data[0]?.addedBy?.firstName, data[0]?.addedBy?.lastName].filter(Boolean).join(' ')} (${getEmployeeId(
                data[0]?.addedBy?.uiid,
                data[0]?.addedBy?.employmentType
              )})`
            : "";
          return (
            <div key={version} className="mb-8">
              <div className="my-4 font-semibold flex justify-between ">
                <div>
                  Reconciliation - (V{version}) -{" "}
                  {dayjs(data[0]?.addedOn || "")
                    .utc()
                    .format("MM/DD/YYYY HH:mm [UTC]")}
                  {addedByName}
                </div>
              </div>
              {/* <div className="h-[50vh] overflow-hidden"> */}
              <div className="h-full overflow-auto">
                <NewTableAdv
                  rows={getMappedRows(data)}
                  columns={columns}
                  serverPagination={true}
                  page={page}
                  limit={limit}
                  // accrodian={(() => {
                  //   const data1 = getMappedRows(data);
                  //   console.log("data",data1);
                  //   return <span>{data1.map(data=>data.name)}</span>
                  // })()}
                  // accrodian={<AccrodianComponent data={mappedRows} />}
                  // accrodian={<AccrodianComponent data={getMappedRows(data)} />}
                  accrodian={<AccordionComponentForTable data={getMappedRows(data)} />}
                  // totalCount={1000}
                  totalCount={totalCountMap[version]}
                  onPageChange={setPage}
                  onLimitChange={handleLimitChange}
                  toolbarRight={{
                    search: false,
                    filter: false,
                    download: false,
                    add: [
                      {
                        component: (
                          <div className="flex gap-3">
                            <Button
                              // type="link"
                              icon="download"
                              size="sm"
                              variant="text"
                              color="info"
                              title={"Export To CSV"}
                              // onClick={() => downloadInvoice()}
                              onClick={() => downloadExcel(version)}
                            />
                          </div>
                        ),
                      },
                    ],
                  }}
                />
              </div>
            </div>
          );
        }) || null}

      {/* confirmationmodal */}
      <Modal
        isOpen={overWriteConfirm}
        title={"Overwrite Confirmation"}
        onClose={handleCloseConfirmationModal}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-md"
      >
        <div>
          <p className="text-sm text-neutrals-900">
            Are you sure you want to overwrite the existing data?
          </p>
          <div className="flex justify-end gap-2 mt-4">
            <Button
              title={"Cancel"}
              variant="outlined"
              onClick={handleCloseConfirmationModal}
            />
            {/* <Button title={"Confirm"} onClick={handleOverwrite} /> */}
            <Button
              title={"Confirm"}
              onClick={() => {
                setOverwriteStatus(true);
              }}
            />
          </div>
        </div>
      </Modal>

      {/* loader_modal */}
      {/* <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop> */}
    </div>
  );
};

export default PayrollSummary;
